import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

export const getTaxVerificationRequirementName = (
  requirement: PayeeRequirement
) => requirement.name || "Taxpayer information";
